// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['appointmentFee', 'isPutting']);
export const getErrMsg = state => state.getIn(['appointmentFee', 'errMsg']);